import { render, staticRenderFns } from "./MarketIcon.vue?vue&type=template&id=76951608"
import script from "./MarketIcon.vue?vue&type=script&lang=js"
export * from "./MarketIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports